function RadioButton({ filterValues, onChange, options = [], valueKey = 'statute' }) {
    let handleChange = (label) => {
        let prev = Array.isArray(filterValues[valueKey]) ? filterValues[valueKey] : []
        let next = prev.includes(label)
            ? prev.filter(a => a !== label)
            : [...prev, label]
        
        onChange({ ...filterValues, [valueKey]: next })
    }

    let optionRender = options.map((a) => {
        let isToggled = (Array.isArray(filterValues[valueKey]) ? filterValues[valueKey] : []).includes(a.label)
        let classList = "tog"
        if (isToggled)
            classList += " on"
        return <span onClick={() => handleChange(a.label)} key={a.label} className={classList}>{a.label}</span>
    })

    return (
                <div className="tog-wrap">
                    {optionRender}
                </div>
    )
}

export default RadioButton;